import { Dialog } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import ReactCrop, { Crop, centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
const MDButton = require("components/MDButton/index.js").default;

export const CropImageDialog = ({
  image,
  imageCropped,
}: {
  image?: File;
  imageCropped: (image: File) => void;
}) => {
  const [crop, setCrop] = useState<Crop | undefined>();
  const [imageSize, setImageSize] = useState<{ width: number; height: number } | null>(null);
  const hasSetCrop = useRef(false); // Prevents infinite loop

  useEffect(() => {
    hasSetCrop.current = false; // Reset crop
  }
  , [image]);

  return (
    <Dialog
      open={!!image}
      sx={{
        "& .MuiDialog-paper": {
          width: "auto",
          height: "auto",
          maxWidth: "90vw",
          maxHeight: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      {image && (
        <ReactCrop crop={crop} onChange={(c) => setCrop(c)} aspect={1}>
          <img
            src={URL.createObjectURL(image)}
            onLoad={(e) => {
              if (hasSetCrop.current) return; // Prevent infinite loop
              hasSetCrop.current = true; // Mark crop as set

              const img = e.currentTarget;
              const isHorizontal = img.naturalWidth > img.naturalHeight;
              const smallest = isHorizontal ? img.clientHeight : img.clientWidth;
              setImageSize({ width: img.clientWidth, height: img.clientHeight });


              setCrop({
                unit: "px",
                width: smallest,
                height: smallest,
                x: (img.clientWidth  - smallest) / 2,
                y: (img.clientHeight - smallest) / 2,
              });
            }}
            style={{
              maxWidth: "90vw",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </ReactCrop>
      )}
      <MDButton
        variant="contained"
        color="primary"
        onClick={() => {
          if (crop && imageSize) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imageElement = document.createElement("img");
            imageElement.src = URL.createObjectURL(image!);
            imageElement.onload = () => {
              const scaleX = imageElement.naturalWidth / imageSize.width;
              const scaleY = imageElement.naturalHeight / imageSize.height;
              const croppedWidth = crop.width! * scaleX
              const croppedHeight = crop.height! * scaleY
              const croppedX = crop.x! * scaleX 
              const croppedY = crop.y! * scaleY

              canvas.width = croppedWidth;
              canvas.height = croppedHeight;
              ctx?.drawImage(
                imageElement,
                croppedX,
                croppedY,
                croppedWidth,
                croppedHeight,
                0,
                0,
                croppedWidth,
                croppedHeight
              );

              canvas.toBlob((blob) => {
                if (blob) {
                  const file = new File([blob], image!.name, { type: blob.type });
                  imageCropped(file);
                }
              });
            };
          }
        }}
      >
        Crop
      </MDButton>
    </Dialog>
  );
};